@if (state$ | async; as state) {
  @if (composerOpen()) {
    <div class="order-note-composer">
      <textarea #composer class="order-note-composer-input" rows="3" placeholder="Nowa notatka..."
        [disabled]="state.saving"
        (keydown.escape)="closeComposer()"></textarea>
      <button class="btn" [disabled]="state.saving" (click)="onSaveClick(composer.value)">Zapisz</button>
    </div>
  }

  @if (state.saveError) {
    <div class="order-notes-save-error">{{ state.saveError }}</div>
  }

  @if (state.loading) {
    <!-- two notes' shadows: a header line and a body line each (0127) -->
    <div class="order-note">
      <div class="order-note-header"><span class="shadow shadow-short"></span></div>
      <span class="shadow shadow-long"></span>
    </div>
    <div class="order-note">
      <div class="order-note-header"><span class="shadow shadow-short"></span></div>
      <span class="shadow shadow-long"></span>
    </div>
  } @else {
    @for (note of state.notes ?? []; track note.id) {
      <div class="order-note">
        <div class="order-note-header">
          <div class="order-note-header-name">{{ note.userName }}</div>
          <div class="font-monospace">{{ note.createdAt | date:'HH:mm dd.MM.yyyy' }}</div>
        </div>
        <div class="order-note-body">{{ note.content }}</div>
      </div>
    } @empty {
      <div class="order-notes-empty">Brak notatek</div>
    }
  }
}
